export default __webpack_public_path__ + "static/media/icon-export-regular.f9a5f01a.svg";